import React from 'react';

/**
 * 딤 처리 컴포넌트
 */

interface IDimProps {
  onClick?: () => void;
}

const Dim = ({onClick}: IDimProps) => {
  return <div className='dim' onClick={onClick}></div>;
};

Dim.defaultProps = {
  onClick: undefined,
};

export default Dim;
